import { createFileRoute } from "@tanstack/react-router";
import { Paper } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminProgramsList from "@/common/components/views/AdminProgramsList";
import { useProgramsPermissions } from "@/pages/admin/programs";

export const Route = createFileRoute("/app/admin/programs/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanViewAllPrograms, userCanViewAllSets } = useProgramsPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Programs", link: null },
        ]}
      />
      <h1>Program Management</h1>
      <Paper>
        <AdminProgramsList
          userCanViewAllPrograms={userCanViewAllPrograms}
          userCanViewAllSets={userCanViewAllSets}
        />
      </Paper>
    </>
  );
}
